import tailwindJSON from '../tailwind.config.json';

import { ITailwindCssPluginConfig } from './shared/types/ITailwindCssPlugin';
import { gridPlugin } from './styleguide/Grid/Grid.plugin';
import { typographyPluginGellix } from './styleguide/Typography-Gellix/Typography-Gellix.plugin';
import { typographyPlugin } from './styleguide/Typography/Typography.plugin';

// eslint-disable-next-line @typescript-eslint/no-var-requires
const plugin = require('tailwindcss/plugin');

const tailwindConfig: any = tailwindJSON;

const pluginArr = [
    plugin(function (config: ITailwindCssPluginConfig): void {
        typographyPlugin(config);
        typographyPluginGellix(config);
        gridPlugin(config);
    }),
];

tailwindConfig.plugins = pluginArr;

export const tailwind: any = tailwindConfig;
